import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { CurrencyProvider } from "./context/CurrencyContext";
import Home from "./pages/Home";
import Business from "./pages/Business";
import SampleReport from "./pages/SampleReport";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Refund from "./pages/Refund";
import CarService from "./pages/CarService";
import CarServiceSEOPage from "./pages/seo/CarServiceSEOPage";
import CarServiceHub from "./pages/seo/CarServiceHub";
import CompareCompetitorPage from "./pages/seo/CompareCompetitorPage";
import BestPage from "./pages/seo/BestPage";
import FAQPage from "./pages/seo/FAQPage";
import { PaymentProvider } from "./context/PaymentContext";
import ScrollToTop from "./components/ScrollToTop";
import EnvBadge from "./components/EnvBadge";
import { applyUrlOverride } from "./utils/envOverride";

// Consume any ?crm_url=... / ?crm_key=... / ?crm=reset URL params at app boot.
// Runs once at module load — before any component mounts or API calls fire.
applyUrlOverride();

const CRM_BASE_URL = "https://crm.wisedrive.com";

// Redirects /report/verify?... → CRM /inspections/verify?...
function ReportVerifyRedirect() {
  const { search } = useLocation();
  useEffect(() => {
    window.location.replace(`${CRM_BASE_URL}/inspections/verify${search}`);
  }, [search]);
  return null;
}

function App() {
  return (
    <div className="App">
      <CurrencyProvider>
        <PaymentProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route path="/sample-report" element={<SampleReport />} />
              <Route path="/carservice" element={<CarService />} />
              {/* Programmatic SEO — universal template, 6 tiers driven by URL params.
                  /car-service                             — national hub
                  /car-service/{city}/{seg2?}/{seg3?}/{seg4?}
                  See CarServiceSEOPage.jsx for tier disambiguation. */}
              <Route path="/car-service" element={<CarServiceHub />} />
              <Route path="/car-service/:city" element={<CarServiceSEOPage />} />
              <Route path="/car-service/:city/:seg2" element={<CarServiceSEOPage />} />
              <Route path="/car-service/:city/:seg2/:seg3" element={<CarServiceSEOPage />} />
              <Route path="/car-service/:city/:seg2/:seg3/:seg4" element={<CarServiceSEOPage />} />

              {/* GEO (Generative Engine Optimization) — comparison + best-X + FAQ
                  Note: React Router v6 doesn't support partial-segment params,
                  so city is a separate path segment for the per-city routes. */}
              <Route path="/compare" element={<CompareCompetitorPage />} />
              <Route path="/compare/:slug" element={<CompareCompetitorPage />} />
              <Route path="/best-car-inspection-india" element={<BestPage kind="inspection-india" />} />
              <Route path="/best-doorstep-car-service/:city" element={<BestPage kind="doorstep-city" />} />
              <Route path="/best-used-car-inspection/:city" element={<BestPage kind="inspection-city" />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/report/verify" element={<ReportVerifyRedirect />} />
              <Route path="/:countryCode" element={<Home />} />
              <Route path="/:countryCode/business" element={<Business />} />
              <Route path="/:countryCode/privacy" element={<Privacy />} />
              <Route path="/:countryCode/terms" element={<Terms />} />
              <Route path="/:countryCode/refund" element={<Refund />} />
            </Routes>
          </BrowserRouter>
          <EnvBadge />
        </PaymentProvider>
      </CurrencyProvider>
    </div>
  );
}

export default App;
